import React, { useEffect, useState, useMemo } from 'react'
import GatewayType from '../GatewayType'
import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import { formatBooleanColumn } from '../../utils/DatatableUtil'
import DataTable, { CaptionButton } from '../../components/DataTable'
import Loading from '../../layout/Loading'
import RootCertificateService from '../../service/RootCertificateService'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons'


const RootCertificate: GatewayType = () => {
    const { t } = useTranslation()
    const [cert, setCert] = useState({} as any)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        RootCertificateService.getCertificateDetails()
            .then((cert) => setCert(cert))
            .finally(() => setLoading(false))
    }, [])

    const columns = useMemo(() => {
        return [
            {
                text: 'label',
                dataField: 'label',
                classes: 'font-weight-bolder',
                sort: true,
            },
            {
                text: 'value',
                dataField: 'value',
                sort: true,
                formatter: (cell: any, row: any) => (row.label === t('disabled') ? formatBooleanColumn(cell) : cell),
            },
        ]
    }, [t])

    const data = getData(cert, t)

    var captionButtons: CaptionButton[] = [
        {
            onClick: () => RootCertificateService.getCertificate(),
            text: t('rootCertificate.download'),
            icon: faFileDownload,
        },
    ]

    return (
        <Loading isLoading={loading}>
            <DataTable
                keyField='label'
                data={data}
                columns={columns}
                headerClasses='d-none'
                searchable={false}
                caption={t('rootCertificate.text')}
                helpLink={t('rootCertificate.helpLink')}
                captionButtons={captionButtons}
            />
        </Loading>
    )
}

function getData(cert: any, t: TFunction) {
    return Object.keys(cert).length > 0
        ? [
            {
                label: t('rootCertificate.issuer'),
                value: cert.issuer,
            },
            {
                label: t('rootCertificate.subject'),
                value: cert.subject,
            },
            {
                label: t('rootCertificate.serialNo'),
                value: cert.serialNo,
            },
            {
                label: t('rootCertificate.validFrom'),
                value: cert.validFrom,
            },
            {
                label: t('rootCertificate.validUntil'),
                value: cert.validUntil,
            },
        ]
        : []
}

export default RootCertificate